import React from "react";
import { Layout } from "antd";
import Navbar from "../components/Navbar";
import AppRoutes from "../routes/AppRoutes";

const { Content } = Layout;

const MainLayout = () => {
  return (
    <Layout style={{ background: 'transparent' }}>
      <Navbar />
      <Content style={{ padding: "20px" }}>
        <AppRoutes />
      </Content>
      {/* <Footer style={{ textAlign: "center" }}>Alyson.ai ©2025</Footer> */}
    </Layout>
  );
};

export default MainLayout;
